const testimonials = [
  {
    name: "Jennifer L.",
    location: "Winter Park, FL",
    rating: 5,
    text: "I had a work trip to London in 6 days and realized my passport had expired. Fast Passport Center got my renewal processed and back to me in 3 days. Their team answered every call and kept me updated daily.",
    service: "Passport Renewal",
  },
  {
    name: "David K.",
    location: "Kissimmee, FL",
    rating: 5,
    text: "My daughter's passport got damaged right before our Disney cruise. I was completely stressed out. FPC walked me through the replacement process and had a new one in her hands in under a week. Lifesavers.",
    service: "Damaged Passport",
  },
  {
    name: "Amanda R.",
    location: "Dr. Phillips, FL",
    rating: 5,
    text: "First-time passport for my teenager. I had no idea what I was doing. They sent a crystal-clear checklist, told me exactly which clerk to visit in Orlando, and handled the expedite after. So smooth.",
    service: "New Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function OrlandoTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Orlando Travelers Say About Our Emergency & Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Orlando, Winter Park, and Kissimmee who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}